export function removeLeadingSlash(input) {
  return input && input.startsWith('/') ? input.slice(1) : input;
}
